module.exports = __webpack_public_path__ + "static/media/Phone-blue.4a4a0eaa.svg";